import __vue_normalize__ from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Eye_close_16.vue_rollup-plugin-vue=script.js';

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M14.3536 2.35355C14.5488 2.15829 14.5488 1.84171 14.3536 1.64645C14.1583 1.45118 13.8417 1.45118 13.6464 1.64645L11.5713 3.72158C11.4254 3.65991 11.2772 3.60187 11.127 3.54757C6.7273 1.95714 1.78431 3.94879 0 7.99996C0.702058 9.59236 1.92736 10.9227 3.4823 11.8106L1.64645 13.6464C1.45118 13.8417 1.45118 14.1583 1.64645 14.3536C1.84171 14.5488 2.15829 14.5488 2.35355 14.3536L14.3536 2.35355ZM5.55463 9.73827L6.27691 9.01598C6.10097 8.71823 6 8.3709 6 8C6 6.89543 6.89543 6 8 6C8.3709 6 8.71823 6.10097 9.01598 6.27691L9.73827 5.55463C9.24786 5.2054 8.64792 5 8 5C6.34315 5 5 6.34315 5 8C5 8.64792 5.2054 9.24786 5.55463 9.73827ZM9.98135 7.72575L7.72575 9.98135C7.81541 9.99365 7.90696 10 8 10C9.10457 10 10 9.10457 10 8C10 7.90696 9.99365 7.81541 9.98135 7.72575ZM8 11C7.61583 11 7.24852 10.9278 6.91091 10.7962L5.15715 12.55C9.48355 13.9564 14.254 11.9642 16 8.00004C15.3932 6.62378 14.3956 5.44324 13.1322 4.57494L10.7962 6.91091C10.9278 7.24852 11 7.61583 11 8C11 9.65685 9.65685 11 8 11Z"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
